import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bidi-road-map',
  templateUrl: './road-map.component.html',
  styleUrls: ['./road-map.component.scss']
})
export class RoadMapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
